import { MetaTag } from './view';
export default MetaTag;
